{ license_url } = require 'lib/constants'

LicenceTooltipText = ({ text }) ->
  <div className="licence-tooltip-text">
    <div className="licence-tooltip-text__text" dangerouslySetInnerHTML={__html: text} />
    <a className="licence-tooltip-text__link" href={license_url} target="_blank">{license_url}</a>
  </div>

module.exports = LicenceTooltipText
